import { Component, OnInit, Input } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';

@Component({
    selector: 'campaign-image-preview',
    templateUrl: './image-preview.modal.component.html',
    styleUrls: [
        './image-preview.scss'
    ]
})
export class CampaignImagePreviewModalComponent implements OnInit {
    @Input() imagePath: string;

    constructor(
        public modalRef: BsModalRef,
    ) {}

    ngOnInit() {}

    close(): void {
        this.modalRef.hide();
    }
}





// WEBPACK FOOTER //
// ./src/app/shared/campaign-modal-component/image-previwer/image-preview.modal.component.ts